module.exports = __webpack_public_path__ + "img/casa_garden_and_fundacao_oriente_.9cb179cf.jpg";